import { render, staticRenderFns } from "./HeaderDetail.vue?vue&type=template&id=662e6b66"
import script from "./HeaderDetail.vue?vue&type=script&lang=js"
export * from "./HeaderDetail.vue?vue&type=script&lang=js"
import style0 from "./HeaderDetail.vue?vue&type=style&index=0&id=662e6b66&prod&lang=scss"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports